module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v("\n\t\tFilter by Academy Id: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "initial": true
      }
    }],
    attrs: {
      "name": "filter",
      "type": "text",
      "data-vv-rules": "numeric",
      "placeholder": "Academy Id"
    },
    domProps: {
      "value": _vm._s(_vm.filter)
    },
    on: {
      "blur": _vm.updateFilter,
      "keyup": function($event) {
        if ($event.keyCode !== 13) { return; }
        _vm.updateFilter($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('filter')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("invald academy id")]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("Activity Log")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "activity-log-container",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "10"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-bordered activity-log-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.logdata), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.firstname) + " " + _vm._s(row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.acadid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.action))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "timestamp",
        rawName: "v-timestamp",
        value: (row.time),
        expression: "row.time"
      }]
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.status))])])
  }))]), _vm._v(" "), (_vm.loading) ? _c('loading-bar') : _vm._e(), _vm._v(" "), (_vm.end) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("No More Log Entries")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Academy id")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6974e4d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityLog.vue
// module id = 415
// module chunks = 2